import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../App';
import { Globe, LogOut, Home, User, Gamepad2, CreditCard } from 'lucide-react';
import './Navbar.css';

function Navbar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = React.useContext(AuthContext);
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.dir = lng === 'ar' ? 'rtl' : 'ltr';
  };
  
  return (
    <nav className="navbar" data-testid="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" data-testid="navbar-brand">
          <img src="/al3abi-logo.png" alt="Al3abi" className="brand-logo" />
          <span>Al3abi</span>
        </Link>
        
        {user && (
          <div className="navbar-links">
            <Link to="/dashboard" className="nav-link" data-testid="nav-dashboard">
              <Home size={20} />
              <span>{t('dashboard')}</span>
            </Link>
            <Link to="/our-games" className="nav-link" data-testid="nav-our-games">
              <Gamepad2 size={20} />
              <span>{t('ourGames')}</span>
            </Link>
            <Link to="/subscribe" className="nav-link" data-testid="nav-subscribe">
              <CreditCard size={20} />
              <span>{t('subscribe')}</span>
            </Link>
            <Link to="/profile" className="nav-link" data-testid="nav-profile">
              <User size={20} />
              <span>Profile</span>
            </Link>
          </div>
        )}
        
        <div className="navbar-actions">
          <div className="language-switcher" data-testid="language-switcher">
            <Globe size={20} />
            <select 
              value={i18n.language} 
              onChange={(e) => changeLanguage(e.target.value)}
              data-testid="language-select"
            >
              <option value="en">EN</option>
              <option value="ar">AR</option>
              <option value="fr">FR</option>
            </select>
          </div>
          
          {user && (
            <button onClick={logout} className="btn-logout" data-testid="logout-button">
              <LogOut size={20} />
              <span>{t('logout')}</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
